import "../../assets/DismissButton.css";
import { jsxs as n, jsx as t } from "react/jsx-runtime";
import { c as m } from "../../index-LULxUVKG.js";
import { Icon as d } from "../Icon/Icon.js";
import { VisuallyHidden as c } from "../VisuallyHidden/VisuallyHidden.js";
const u = "_dismissButton_19f04_3", B = "_withBorder_19f04_12", _ = "_inverted_19f04_36", s = {
  dismissButton: u,
  withBorder: B,
  inverted: _
}, v = ({
  inverted: i = !0,
  withBorder: r = !0,
  className: o,
  ...e
}) => /* @__PURE__ */ n(
  "button",
  {
    className: m(
      s.dismissButton,
      {
        [s.inverted]: i,
        [s.withBorder]: r
      },
      o
    ),
    ...e,
    children: [
      /* @__PURE__ */ t(d, { name: "cross", size: "16" }),
      /* @__PURE__ */ t(c, { children: "Dismiss" })
    ]
  }
);
export {
  v as DismissButton
};
